import React, { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';

// Sales persons of the current workspace (Tag Domain), shared by list editors.
let people = [];
let loaded = false;
const subs = new Set();
export async function loadSalesPersons() {
  try { people = (await notesApi.get('/notes/tag-workspace/sales-persons')).data || []; } catch { people = []; }
  loaded = true; subs.forEach((f) => f());
}
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
export const useSalesPersons = () => useSyncExternalStore(subscribe, () => people);
export const salesNames = (ids) => (ids || []).map((id) => people.find((p) => p.id === id)?.name).filter(Boolean);

// Multi-select dropdown of sales persons for a list.
export function SalesPicker({ value = [], onChange, testid = 'sales-picker', up = false, allow = null }) {
  const all = useSalesPersons();
  const list = allow ? all.filter((p) => allow.includes(p.id)) : all;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => { if (!loaded) loadSalesPersons(); }, []);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  const names = salesNames(value);
  return (
    <div ref={ref} className="relative min-w-0" data-testid={testid}>
      <button type="button" onClick={() => setOpen(!open)} className="flex h-9 w-full min-w-[180px] items-center justify-between gap-2 rounded-lg border border-input bg-background px-3 text-left text-sm" data-testid={`${testid}-button`}>
        <span className={`truncate ${names.length ? 'text-foreground' : 'text-muted-foreground'}`}>{names.length ? `Sales: ${names.join(', ')}` : 'Sales person(s)'}</span>
        <ChevronDown size={14} className="shrink-0 text-muted-foreground" />
      </button>
      {open ? (
        <div className={`absolute left-0 right-0 z-[320] max-h-56 min-w-[200px] overflow-y-auto rounded-lg border border-border bg-card shadow-xl ${up ? 'bottom-full mb-1' : 'mt-1'}`} data-testid={`${testid}-dropdown`}>
          {list.length ? list.map((p) => (
            <button type="button" key={p.id} onClick={() => toggle(p.id)} className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-secondary ${value.includes(p.id) ? 'bg-[hsl(var(--accent))]' : ''}`} data-testid={`${testid}-option`}>
              <span className={`grid h-4 w-4 shrink-0 place-items-center rounded border ${value.includes(p.id) ? 'border-primary bg-primary text-primary-foreground' : 'border-input'}`}>{value.includes(p.id) ? <Check size={11} /> : null}</span>
              {p.name}
            </button>
          )) : <div className="px-3 py-3 text-center text-xs text-muted-foreground" data-testid={`${testid}-empty`}>{allow ? 'No sales person has rights to this rate card.' : 'No sales persons yet — the super admin marks them in Manage users.'}</div>}
        </div>
      ) : null}
    </div>
  );
}
